import { createRequestTypes } from '../shared/types';

export const EMBED_SETTINGS_UPDATE =
  'line-up/EVENT_EMBED/EMBED_SETTINGS_UPDATE';
export const EMBED_SETTINGS = createRequestTypes('eventEmbed', 'EVENT_EMBED');
export const UPDATE = createRequestTypes('eventEmbed', 'UPDATE');
export const LOAD_EMBED_SETTINGS = 'line-up/EVENT_EMBED/LOAD_EMBED_SETTINGS';
